import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip as MaterialToolTip, makeStyles } from '@material-ui/core';
import cn from 'classnames';
import styles from './index.module.scss';
import { infoText } from 'utils/constants/index';
import { ConditionalWrapper } from 'utils/render';
import { useTranslation } from 'react-i18next';

const useStyle = makeStyles({
  tooltip: {
    fontSize: '0.8rem',
    background: '#2f2f2f',
    border: '1px solid #58595b',
  },
});

const Tooltip = ({
  text,
  className,
  icon = infoText,
  displayIcon = true,
  children,
}) => {
  const { t } = useTranslation();
  const [show, setShow] = React.useState(false);
  const classes = useStyle();

  const isTextObject = typeof text === 'object';

  return (
    <MaterialToolTip
      title={isTextObject ? t(text.value) : t(text)}
      className={styles.tooltip}
      classes={{ tooltip: classes.tooltip }}
      open={show}
      onMouseDown={e => {
        if (e.target instanceof Element) {
          e.preventDefault();
          setShow(false);
        }
      }}
      {...(!children && {
        onMouseEnter: () => setShow(true),
        onMouseLeave: () => setShow(false),
      })}
    >
      <span>
        <ConditionalWrapper
          condition={isTextObject}
          wrapper={children => (
            <a
              className={styles.link}
              href={text.link}
              target={text.target || '_blank'}
              {...(text.target === '_blank' && { rel: 'noopener noreferrer' })}
            >
              <div
                onMouseEnter={() => setShow(true)}
                onMouseLeave={() => setShow(false)}
              >
                {children}
              </div>
            </a>
          )}
        >
          {displayIcon && (
            <span
              className={cn(styles.size, className)}
              onMouseEnter={() => setShow(true)}
              onMouseLeave={() => setShow(false)}
            >
              {icon}
            </span>
          )}
          <div
            {...(children && {
              onMouseEnter: () => setShow(true),
              onMouseLeave: () => setShow(false),
            })}
          >
            {children && children}
          </div>
        </ConditionalWrapper>
      </span>
    </MaterialToolTip>
  );
};

export const InfoPropTypes = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.shape({
    value: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }),
]);

Tooltip.propTypes = {
  text: InfoPropTypes,
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  className: PropTypes.string,
  children: PropTypes.node,
  displayIcon: PropTypes.bool,
};
export default Tooltip;
